import component from './HeatingBuildingType.vue';
import { StepCategoryId, StepId } from '~/consts/assistant-steps';
import {
  FormMultipleChoiceComponentConfig,
  FormMultipleChoiceValueType,
  StepDefinition,
} from '@/interfaces/step-definition';
import { AssistantStepContext } from '@/interfaces/context';
import { FormFieldType } from '@/consts/input-types';
import { FormFieldGroupId } from '~/consts/assistant-form-field-groups';

export interface HeatingBuildingTypeStepContext extends AssistantStepContext {
  buildingType: FormMultipleChoiceValueType;
}

const config: StepDefinition = {
  component,
  hideSkipMessage: () => true,
  fields: [
    {
      component: {
        columns: 4,
        disableUnselect: true,
        options: [
          {
            value: 'singleFamily',
            image: {
              file: 'img/icon/single-family.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
          {
            value: 'multiFamily',
            image: {
              file: 'img/icon/multi-family.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
          {
            value: 'apartment',
            image: {
              file: 'img/icon/appartment.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
          {
            value: 'other',
            image: {
              file: 'img/icon/other.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
        ],
        singleAnswer: true,
        verticalOptionLayout: true,
      } as FormMultipleChoiceComponentConfig,
      groupId: FormFieldGroupId.OBJECT,
      name: 'buildingType',
      required: true,
      type: FormFieldType.MultipleChoice,
    },
  ],
  id: StepId.HEATING_BUILDING_TYPE,
  categoryId: StepCategoryId.HEATING,
};

export default config;
